import { coreDataSecurityApplicationsIdMapSlice } from './update';

export const updateApplicationReferences = coreDataSecurityApplicationsIdMapSlice.syncActionCreator;
